import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormControlName, FormGroupDirective, FormGroupName, FormsModule } from '@angular/forms';
import { DefaultLocaleConfig, LOCALE_CONFIG, LocaleService, NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { DateTime } from 'luxon';

@Component({
  selector: 'esp-filtro-fecha',
  standalone:true,
  imports:[CommonModule, FormsModule, NgxDaterangepickerMd, CdkMenuModule],
  providers: [
    LocaleService,
    { provide: LOCALE_CONFIG, useValue: DefaultLocaleConfig },
  ],
  templateUrl: './filtro-fecha.component.html',
  styleUrls: ['./filtro-fecha.component.scss']
})
export class FiltroFechaComponent implements OnChanges{
  private readonly appTimezone = 'America/Caracas';

  @Input()
  setSelectionBg: string = '#14b8a6';

  @Input()
  setButtonBg: string = '#0d9488';

  @Input()
  setOptionSelected: string = '#0088CC';

  @Input()
  setTextColour: string = '#057EC9';

  @Input()
  setDateSelectedDefault!: number;

  @Input()
  dateInterval! : {dateIni: string, dateFin: string};

  @Input()
  isDisabled!: boolean;

  @Input()
  setDate!: number;

  @Output()
  sendDateFilter = new EventEmitter<any>(); //Se requiere de una funcion en donde se llame el valor seleccionado para, posteriormente, almacenarlo en donde se requiera
  
  @Output()
  sendDateFilterWithCeros = new EventEmitter<any>(); //Ejemplo 01/01/2023 - 02/02/2023

  @Output()
  sendDateFilterWithoutCeros = new EventEmitter<any>(); //Ejemplo 1/1/2023 - 2/2/2023

  @Output()
  sendDateFilterUSDate = new EventEmitter<any>(); //Ejemplo 06/23/2023 - 12/23/2023

  datoFecha!: string;

  selectedPersonalizado: boolean = false;

  opcionesFecha = [{descripcion: 'Hoy', accion: 1},
                   {descripcion: 'Ayer', accion: 2},
                   {descripcion: 'Esta Semana', accion: 3},
                   {descripcion: 'Semana Pasada', accion: 4},
                   {descripcion: 'Este Mes', accion: 5},
                   {descripcion: 'Mes Pasado', accion: 6},
                   {descripcion: 'Trimestre Actual', accion: 7},
                   {descripcion: 'Trimestre Anterior', accion: 8},
                   {descripcion: 'Este Año', accion: 9},
                   {descripcion: 'Año Pasado', accion: 10},
                   {descripcion: 'Personalizado', accion: 11}];
  selectedSize = {descripcion: '', accion: 0};

  @ViewChild('menu', { static: true }) menu!: TemplateRef<any>;

  constructor() { }

  ngOnInit(): void {
    if(this.setSelectionBg != undefined){
      document.documentElement.style.setProperty('--fondo-selected-date',this.setSelectionBg);
    }
    else{
      document.documentElement.style.setProperty('--fondo-selected-date','#14b8a6');
    }
    if(this.setButtonBg != undefined){
      document.documentElement.style.setProperty('--fondo-choose-range-date',this.setButtonBg);
    }
    else{
      document.documentElement.style.setProperty('--fondo-choose-range-date','#0d9488');
    }
    if(this.setOptionSelected != undefined){
      document.documentElement.style.setProperty('--fondo-opcion-selected',this.setOptionSelected);
    }
    else{
      document.documentElement.style.setProperty('--fondo-opcion-selected','#0088CC');
    }
    if(this.setTextColour != undefined){
      document.documentElement.style.setProperty('--color-texto-selected',this.setTextColour);
    }
    else{
      document.documentElement.style.setProperty('--color-texto-selected','#057EC9');
    }
    if (this.setDateSelectedDefault) {
      this.selectRangoFecha(this.setDateSelectedDefault)
    }
    else{
      if(this.dateInterval){
        this.setDateInterval();
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dateInterval'] && changes['dateInterval'].currentValue) {
      this.setDateInterval(); // Actualizar el rango basado en la nueva fecha
    }
  }

  private parseLocalISODate(value?: string): DateTime | null {
    if (!value) {
      return null;
    }

    const parsed = DateTime.fromFormat(String(value).trim(), 'yyyy-MM-dd', { zone: this.appTimezone });
    return parsed.isValid ? parsed.startOf('day') : null;
  }

  private formatLocalDate(value: DateTime): string {
    return value.setZone(this.appTimezone).toFormat('dd/MM/yyyy');
  }

  setDateInterval() {
    const { dateIni, dateFin } = this.dateInterval || {};
    const firstDay = this.parseLocalISODate(dateIni);
    const today = this.parseLocalISODate(dateFin);

    if (!firstDay || !today) {
      console.error('Error: Las fechas proporcionadas no son válidas.');
      return;
    }

    const start = firstDay <= today ? firstDay : today;
    const end = firstDay <= today ? today : firstDay;
    this.datoFecha = `${this.formatLocalDate(start)} - ${this.formatLocalDate(end)}`;
  
    this.selectedSize = this.opcionesFecha.find((x) => x.accion === 11)!;
    this.orderDatesAsRequired(this.datoFecha, 11);
    this.sendDateFilter.emit(this.datoFecha);
  }
  

  selectRangoFecha(value: number){
    this.selectedPersonalizado = false;
    const today = DateTime.now().setZone(this.appTimezone).startOf('day');
    let startDate = today;
    let endDate = today;

    switch (value) {
      case 1:
        break;
      case 2:
        startDate = today.minus({ days: 1 });
        endDate = startDate;
        break;
      case 3:
        startDate = today.startOf('week');
        break;
      case 4: {
        const startLastWeek = today.startOf('week').minus({ weeks: 1 });
        startDate = startLastWeek;
        endDate = startLastWeek.plus({ days: 6 });
        break;
      }
      case 5:
        startDate = today.startOf('month');
        break;
      case 6:
        startDate = today.minus({ months: 1 }).startOf('month');
        endDate = today.startOf('month').minus({ days: 1 });
        break;
      case 7:
        startDate = today.startOf('quarter');
        break;
      case 8:
        startDate = today.startOf('quarter').minus({ quarters: 1 });
        endDate = today.startOf('quarter').minus({ days: 1 });
        break;
      case 9:
        startDate = today.startOf('year');
        break;
      case 10:
        startDate = today.minus({ years: 1 }).startOf('year');
        endDate = today.startOf('year').minus({ days: 1 });
        break;
      default:
        return;
    }

    this.datoFecha = `${this.formatLocalDate(startDate)} - ${this.formatLocalDate(endDate)}`;
    this.selectedSize = this.opcionesFecha.find((x)=> x.accion == value)!;
    this.orderDatesAsRequired(this.datoFecha, value);
    this.sendDateFilter.emit(this.datoFecha);
  }

  choosedDate(event : any){
    this.selectedSize = {descripcion: 'Personalizado', accion: 11};
    this.selectedPersonalizado = true;
    //console.log(event.chosenLabel)
    this.datoFecha = event.chosenLabel.split('-')[0].trim()+' - '+event.chosenLabel.split('-')[1].trim();
    //console.log(this.datoFecha);
    this.orderDatesAsRequired(this.datoFecha, 11);
    this.sendDateFilter.emit(this.datoFecha);
  }

  orderDatesAsRequired(rango:string, opcion:number){
    var rangoWithoutCeros, rangoWithCeros, rangoUS;
    var fecInicio, fecFin;
    var anioInicio, anioFin;
    var mesInicio, mesFin;
    var diaInicio, diaFin;
    fecInicio = rango.split(' - ')[0];
    fecFin = rango.split(' - ')[1];
    anioInicio = fecInicio.split('/')[2];
    anioFin = fecFin.split('/')[2];
    mesInicio = fecInicio.split('/')[1];
    mesFin = fecFin.split('/')[1];
    diaInicio = fecInicio.split('/')[0];
    diaFin = fecFin.split('/')[0];
    if (opcion < 11) {
      this.sendDateFilterWithoutCeros.emit(rango);
      diaInicio = this.convertToTwoDigits(diaInicio);
      mesInicio = this.convertToTwoDigits(mesInicio);
      diaFin = this.convertToTwoDigits(diaFin);
      mesFin = this.convertToTwoDigits(mesFin);
      fecInicio = diaInicio + '/' + mesInicio + '/' + anioInicio;
      fecFin = diaFin + '/' + mesFin + '/' + anioFin;
      rangoWithCeros = fecInicio + ' - ' + fecFin;
      this.sendDateFilterWithCeros.emit(rangoWithCeros);
      fecInicio = mesInicio + '/' + diaInicio + '/' + anioInicio;
      fecFin = mesFin + '/' + diaFin + '/' + anioFin;
      rangoUS = fecInicio + ' - ' + fecFin;
      this.sendDateFilterUSDate.emit(rangoUS);
    }
    else{
      this.sendDateFilterWithCeros.emit(rango);
      fecInicio = mesInicio + '/' + diaInicio + '/' + anioInicio;
      fecFin = mesFin + '/' + diaFin + '/' + anioFin;
      rangoUS = fecInicio + ' - ' + fecFin;
      this.sendDateFilterUSDate.emit(rangoUS);
      diaInicio = parseInt(diaInicio).toString();
      mesInicio = parseInt(mesInicio).toString();
      diaFin = parseInt(diaFin).toString();
      mesFin = parseInt(mesFin).toString();
      fecInicio = diaInicio + '/' + mesInicio + '/' + anioInicio;
      fecFin = diaFin + '/' + mesFin + '/' + anioFin;
      rangoWithoutCeros = fecInicio + ' - ' + fecFin;
      this.sendDateFilterWithoutCeros.emit(rangoWithoutCeros);
    }
  }

  convertToTwoDigits(n: string): string{
    var convert!: string;
    if(n.length == 1){
      convert = '0'+n;
    }
    else{
      convert = n;
    }
    return convert;
  }
  //Ejemplo de como era directamente en el html
  /*
  selectRangoFecha(value: number){
    var today = new Date();
    //console.log(value);
    if (value == 1){
      var stringFecha = today.toLocaleDateString();
      this.form.get('frmSearchDate')?.setValue(stringFecha + ' - ' + stringFecha);
      this.alterDataTable(value, stringFecha);
    }
    if (value == 2){
      var stringFecha = (new Date(today.valueOf() - 1000*60*60*24)).toLocaleDateString();
      this.form.get('frmSearchDate')?.setValue(stringFecha + ' - ' + stringFecha);
      this.alterDataTable(value, stringFecha);
    }
    if (value == 3){
      let first = today.getDate() - today.getDay()+1;
      var stringFecha = (new Date(new Date(today.setDate(first)).toISOString())).toLocaleDateString()+' - '+((new Date()).toLocaleDateString());
      this.form.get('frmSearchDate')?.setValue(stringFecha);
      this.alterDataTable(value, stringFecha);
    }
    if (value == 4){
      let dimanchLW = today.getDate() - today.getDay(); 
      if (today.getDay() == 0)
        dimanchLW = dimanchLW - 7;//obtiene domingo pasado
      let lundiLW = dimanchLW - 6; //obtiene domingo pasado
      let segundoDia = new Date();
      var stringFecha = (new Date(new Date(today.setDate(lundiLW)).toISOString())).toLocaleDateString()+' - '+((new Date(segundoDia.setDate(dimanchLW))).toLocaleDateString());
      this.form.get('frmSearchDate')?.setValue(stringFecha);
      this.alterDataTable(value, stringFecha);
    }
    if (value == 5){
      var stringFecha = (new Date(new Date(today.setDate(1)).toISOString())).toLocaleDateString()+' - '+((new Date()).toLocaleDateString());
      this.form.get('frmSearchDate')?.setValue(stringFecha);
      this.alterDataTable(value, stringFecha);
    }
    if (value == 6){
      let firstDayMonth = new Date();
      firstDayMonth.setDate(0); 
      var stringFecha = (new Date(new Date(firstDayMonth.setDate(1)).toISOString())).toLocaleDateString()+' - '+(new Date(new Date(today.setDate(0)).toISOString())).toLocaleDateString();
      this.form.get('frmSearchDate')?.setValue(stringFecha);
      this.alterDataTable(value, stringFecha);
    }
    if (value == 7){
      switch (Math.floor((today.getMonth()+3)/3)) {
        case 1:
          today.setMonth(0)
          break;
        case 2:
          today.setMonth(3)       
          break;
        case 3:
          today.setMonth(6)           
          break;
        case 4:
          today.setMonth(9)           
          break;
      }
      today.setDate(1)
      var stringFecha = today.toLocaleDateString()+' - '+(new Date()).toLocaleDateString();
      this.form.get('frmSearchDate')?.setValue(stringFecha);
      this.alterDataTable(value, stringFecha);
    }
    if (value == 8){
      let segundoDia = new Date();
      switch (Math.floor((today.getMonth()+3)/3)) {
        case 1:
          today.setFullYear(today.getFullYear()-1)
          today.setMonth(9)
          segundoDia.setMonth(0)
          break;
        case 2:
          today.setMonth(0)
          segundoDia.setMonth(3)     
          break;
        case 3:
          today.setMonth(3)
          segundoDia.setMonth(6)          
          break;
        case 4:
          today.setMonth(6)
          segundoDia.setMonth(9)         
          break;
      }
      today.setDate(1)
      segundoDia.setDate(0)
      var stringFecha = today.toLocaleDateString()+' - '+segundoDia.toLocaleDateString();
      this.form.get('frmSearchDate')?.setValue(stringFecha);
    }
    if (value == 9){
      let firstDay = new Date();
      firstDay.setMonth(0);
      firstDay.setDate(1);
      var stringFecha = firstDay.toLocaleDateString()+' - '+today.toLocaleDateString();
      this.form.get('frmSearchDate')?.setValue(stringFecha);
    }
    if (value == 10){
      let firstDay = new Date();
      today.setMonth(0);
      today.setDate(0);
      firstDay.setFullYear(firstDay.getFullYear()-1);
      firstDay.setMonth(0);
      firstDay.setDate(1);
      var stringFecha = firstDay.toLocaleDateString()+' - '+today.toLocaleDateString();
      this.form.get('frmSearchDate')?.setValue(stringFecha);
    }
    //console.log(this.form.value);
  }

  alterDataTable(valueAccion: number, stringFecha: string){
    // this.datasource2 = this.dataSourceRespaldo;
    // //console.log(this.datasource2);
    if (valueAccion <= 2) {
      var dia = stringFecha.split('/');
      var fechaEvaluar = new Date(+dia[2], +dia[1]-1, +dia[0]);
      // this.datasource2 = this.dataSource.filter(function(x){
      //   // //console.log((new Date(x.fecRegistro)).toLocaleDateString()," ----", fechaEvaluar.toLocaleDateString());
      //   return (new Date(x.fecRegistro)).toLocaleDateString() <= fechaEvaluar.toLocaleDateString();
      // });      
    }
    else{

    }
  }
  choosedDate(event : any){
    this.form.get('frmSearchDate')?.setValue(event.chosenLabel.split('-')[0].trim()+' - '+event.chosenLabel.split('-')[1].trim());
    this.selectedSize = {descripcion: 'Personalizado', accion: 11};
    //console.log(event.chosenLabel.split(' - '));
  }
  */
}
